import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'auth-wrapper',
  standalone: false,
  templateUrl: './auth-wrapper.component.html',
  styleUrl: './auth-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthWrapperComponent {
  title = input<string | null>(null);
  description = input<string | null>(null);
}
